export default "__VITE_ASSET__5cb73f06__"